import { useMutation, useQuery } from 'react-query';
import { request, request_v2 } from '../utils/axios-utils';

const GetSkuRequestsHistory = async sku => {
    const result = await request({
        method: 'get',
        url: `/requests/fetchRequestHistory?skuId=${sku}`,
    });
    return result;
};

export const useGetSkuRequestsHistory = (data, onSuccess, onError) =>
    useQuery(['fetchCategories', data], () => GetSkuRequestsHistory(data), {
        refetchOnWindowFocus: false,
        enabled: !!data,
        onSuccess,
        onError,
    });
